export default __webpack_public_path__ + "static/media/Solar-Manager@2x.00fdfd9b.png";